export function registerPreloadErrorHandler(): void {
	window.addEventListener('vite:preloadError', event => {
		// When a deployment changes chunk hashes, the old cached index.html references
		// stale URLs that return HTML (404). Vite dispatches this event; without a
		// handler it re-throws the error as an unhandled promise rejection.
		// Guard against infinite reload loops when a chunk is permanently missing
		// (e.g. a failed deployment copy). sessionStorage persists across a reload
		// but is cleared when the tab is closed, allowing one retry per tab session.
		const reloaded = sessionStorage.getItem('vite-preload-error-reloaded');
		if (reloaded) {
			return;
		}
		sessionStorage.setItem('vite-preload-error-reloaded', '1');
		event.preventDefault();
		window.location.reload();
	});
}
